import {EntityManagePage} from "base/entity";

const ManageBombeoPage = () => {
    return <EntityManagePage></EntityManagePage>;
};
export default ManageBombeoPage;
